import React from 'react';
import { Box, Typography } from '@mui/material';

const VersionFooter = () => {
    return (
        <Box
            sx={{
                width: '100%',
                py: 0.5,
                px: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                backdropFilter: 'blur(4px)',
                position: 'fixed',
                bottom: 0,
                left: 0,
                zIndex: 1000,
                textAlign: 'center'
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '0.7rem',
                    fontFamily: 'monospace',
                    userSelect: 'none'
                }}
            >
                Copyright DeepAlert 2025. Version 2026-07-02 10:43
            </Typography>
        </Box>
    );
};

export default VersionFooter;
